import React from 'react';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const OpenSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <span
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        x="0px"
        y="0px"
      >
        <path d="M16,12.24V21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V9A1,1,0,0,1,3,8h8.76l-2,2H4V20H14V14.24ZM9.71,15.71,20,5.41V11a1,1,0,0,0,2,0V3a1,1,0,0,0-1-1H13a1,1,0,0,0,0,2h5.59L8.29,14.29a1,1,0,0,0,1.42,1.42Z" />
      </svg>
    </span>
  );
};

OpenSVG.defaultProps = {
  color: getComputedCSSVariable('black'),
  style: {
    width: '15px',
    height: '15px',
  },
};

export default OpenSVG;
